@if (association$ | async; as association) {
  <crm-activity-card [activity]="activity()" [showAssociationPopover]="false" [icon]="(icon$ | async) || ''">
    <span activity-title>
      @if (headerText$ | async; as headerText) {
        @if (isImportantFieldUpdated$ | async) {
          <strong>{{ headerText }}</strong>
          {{ 'ACTIVITY.RECORD_CHANGE.BY' | translate }}
          {{ changeLogUserName$ | async }}
          @if (showPrimaryAssociation()) {
            {{ 'OBJECT_TYPES.FOR_LABEL' | translate }}
            <ng-container *ngTemplateOutlet="primaryAssociationLink"></ng-container>
          }
        } @else {
          @if (showPrimaryAssociation()) {
            <ng-container *ngTemplateOutlet="primaryAssociationLink"></ng-container>
          }
          {{ headerText }}
        }
      } @else {
        {{ 'ACTIVITY.UNKNOWN_TITLE' | translate }}
      }
    </span>

    <div activity-preview>
      @if (contentText$ | async; as contentText) {
        {{ contentText }}
      }
    </div>
  </crm-activity-card>

  <ng-template #primaryAssociationLink>
    @if (associatedObject$ | async; as associatedObject) {
      @if (primaryAssociationRoute$ | async; as route) {
        <a [routerLink]="route">{{ primaryAssociationDisplayName$ | async }}</a>
      } @else {
        {{ primaryAssociationDisplayName$ | async }}
      }
    }
  </ng-template>
}
